import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import StablishmentRepository from "../../repositories/StablishmentRepository";
import StablishmentEntity from "../../entities/StablishmentEntity";

interface _Props {
    stablishmentRepository: StablishmentRepository;
}

@injectable()
export default class CreateStablishmentUseCase {
    private stablishmentRepository: StablishmentRepository;
    
    constructor(props: _Props) {
        this.stablishmentRepository = props.stablishmentRepository;
    }
    
    public call = async (stablishment: StablishmentEntity) : Promise<Either<ErrorEntity, StablishmentEntity>> => {
        return this.stablishmentRepository.createStablishment(stablishment);
    }
}

export const CreateStablishmentUseCaseName = "CreateStablishmentUseCase";